import { TYPES } from '@/container/types'
import { CustomerDataServiceImpl } from '@/services/customer.service'
import { MockCustomerDataService } from '@/services/mock-customer.service'
import type { App } from 'vue'

export function initializeContainer(app: App) {
  // Auth is now handled by the useAuth composable, no need to provide authStore
  const useMockData = import.meta.env.VITE_USE_MOCK_DATA === 'true'
  if (useMockData) {
    app.provide(TYPES.CUSTOMER_DATA_SERVICE, new MockCustomerDataService())
  } else {
    app.provide(TYPES.CUSTOMER_DATA_SERVICE, new CustomerDataServiceImpl())
  }
}
